import { createAction } from '@reduxjs/toolkit';

export class GetTimeZoneSuccess {
  static get action() {
    return createAction<string>('profile/GET_TIME_ZONE_SUCCESS');
  }
}
